/**
 * Normalise an unknown thrown value to an Error.
 *
 * A string or plain object handed to apm.captureError() is recorded without a
 * stack trace, which collapses unrelated faults under a single APM grouping key.
 * Wrapping guarantees a stack; an existing Error is returned untouched so its
 * original stack is preserved.
 *
 * Objects are JSON-serialised so their contents survive into APM — a bare
 * `String(value)` collapses every object to the useless message "[object Object]".
 * JSON.stringify throws on circular structures, so fall back to String() there.
 */
export function toError(value: unknown): Error {
    if (value instanceof Error) return value
    if (typeof value !== 'object' || value === null) return new Error(String(value))

    try {
        return new Error(JSON.stringify(value))
    }
    catch {
        return new Error(String(value))
    }
}
